exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.roleDetails .el-submenu__title,\n.roleDetails .el-menu-item {\n  display: flex;\n  align-items: center;\n}\n.el-menu-item-group__title {\n  padding-top: 0;\n}\n.v-toolbar__content {\n  padding: 0;\n  border-bottom-style: solid;\n  border-width: medium;\n  border-color: #C92760;\n  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n}\n", ""]);

// exports
